import client from "@/lib/api";

// Envia arquivos grandes (vídeo) em pedaços para driblar o limite de corpo do proxy.
export async function uploadVideoChunked(file, { category = "Vídeos", brandId = null, onProgress } = {}) {
  const CHUNK = 4 * 1024 * 1024; // 4MB
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  let last;
  for (let i = 0; i < total; i++) {
    const chunk = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", i);
    fd.append("total_chunks", total);
    fd.append("filename", file.name);
    fd.append("category", category);
    if (brandId) fd.append("brand_id", brandId);
    fd.append("file", chunk, file.name);
    const { data } = await client.post("/media/upload-chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    last = data;
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  return last?.media;
}
